export default function TransmitterDeviceDTO(transmitterDevice) {
  var p = {};
  if (transmitterDevice) {
    p = {
      id: transmitterDevice.id,
      externalId: transmitterDevice.externalId,
      manufacturerExternalId: transmitterDevice.manufacturerExternalId,
      currentHardwareVersion: transmitterDevice.currentHardwareVersion,
      currentFirmwareVersion: transmitterDevice.currentFirmwareVersion,
      DeviceId: transmitterDevice.id,
    };
  }
  return p;
}
